export const symbolStyle = () => ({
  anchor: 'center',
  size: 12,
  color: '#ffffff',
  haloColor: '#000000',
  overlap: false,
  referenceProperty: null,
});

export const pointStyle = () => ({
  referenceProperty: null,
  size: 12,
  color: '#47da11',
  borderColor: '#ffffff',
  borderWidth: 1,
  stops: [],
  imageStops: [],
  iconScale: 0.075,
  viewType: null,
});

export const lineStyle = () => ({
  referenceProperty: null,
  lineOpacity: 1.0,
  lineColor: '#f29e2e',
  lineWidth: 2,
  minZoom: 1,
  stops: [],
  viewType: 'common',
});

export const polygonStyle = () => ({
  referenceProperty: null,
  lineOpacity: 1.0,
  lineColor: '#f29e2e',
  lineWidth: 1,
  stops: [],
  fillOpacity: 0.5,
  fillColor: '#f29e2e',
  viewType: 'common',
});

export const urlSettings = () => ({
  url: '',
});

export const wfsSettings = () => ({
  geoserverUrl: '',
  geometryAttributeName: 'the_geom',
  layer: '',
  srs: 'EPSG:4326',
  supportsCql: true,
  supportsJsonOutput: true,
  zoomRange: [8, 22],
});
